/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleSetExecutionsSummaryDto
 */
export interface RuleSetExecutionsSummaryDto {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof RuleSetExecutionsSummaryDto
     */
    summary?: { [key: string]: number; };
}

/**
 * Check if a given object implements the RuleSetExecutionsSummaryDto interface.
 */
export function instanceOfRuleSetExecutionsSummaryDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RuleSetExecutionsSummaryDtoFromJSON(json: any): RuleSetExecutionsSummaryDto {
    return RuleSetExecutionsSummaryDtoFromJSONTyped(json, false);
}

export function RuleSetExecutionsSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetExecutionsSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
    };
}

export function RuleSetExecutionsSummaryDtoToJSON(value?: RuleSetExecutionsSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'summary': value.summary,
    };
}

